module.exports = __webpack_public_path__ + "img/single-active.e9d0bdd0.svg";